import React from "react";
import { Typography } from "antd";
import { baseURL } from "../../globalUtils/axiosConfig";

const { Title } = Typography;

const TermReportTable = ({ data, streams, report_type, report_period }) => {
  const {
    user = {},
    teachers = [],
    class: classInfo = {},
    report_log = {},
  } = data || {};

  const {
    first_name = "",
    last_name = "",
    year_level = "",
    login_id = "",
    image_path = "",
  } = user || {};

  const fullName = `${first_name} ${last_name}`;

  const pageStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "210mm",
    minHeight: "297mm",
    background: "white",
    margin: "5px auto",
    fontFamily: "Arial, sans-serif",
    color: "#333",
    boxSizing: "border-box",
    border: "1px solid #ccc",
    background: "#f9f9f9",
    marginBottom: "20px",
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  return (
    <>
      <div style={pageStyle} className="pdf-page" >
        <div
          style={{
            marginBottom: "15px",
            padding: "8px",
            maxWidth: "210mm",
          }}
        >
          <div style={{ position: "absolute", top: "20mm", right: "20mm" }}>
            <img
              src="/apple-touch-icon.png"
              alt="Alsiraat"
              style={{ width: "120px" }}
            />
          </div>

          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h1 style={{ fontSize: "32px", fontWeight: "bold", color: "#222", marginTop: "20px" }}>
              {(report_log?.report_type || "TERM").toUpperCase()}
            </h1>
            <h2 style={{ fontSize: "20px", marginTop: "5px", color: "#777" }}>
              {report_period || "Report Period"}
            </h2>
            <h2 style={{ fontSize: "24px", marginTop: "10px", color: "#555" }}>
              {classInfo?.name ? `${classInfo.name} - ${classInfo.code}` : "CLASS"}
            </h2>
            <h3 style={{ fontSize: "20px", marginTop: "20px", color: "#555" }}>
              {fullName}
            </h3>
            <p>
              <strong>Student ID:</strong> {login_id}
            </p>
            <p>
              <strong>YEAR LEVEL:</strong> {year_level}
            </p>
            <p>
              <strong>Start Date:</strong>{" "}
              {formatDate(report_log?.metadata?.start_date)}
            </p>
            <p>
              <strong>End Date:</strong>{" "}
              {formatDate(report_log?.metadata?.end_date)}
            </p>
            <p>
              <strong>TEACHER{teachers.length > 1 ? "S" : ""}:</strong>{" "}
              {teachers.map((t) => t.name).join(", ")}
            </p>
          </div>

          <div style={{ fontSize: "16px", marginTop: "20px", lineHeight: 1.5 }}>
            <img
              src={image_path ? `${baseURL}/${image_path}` : "/download.png"}
              alt="profile"
              style={{
                width: "120px",
                marginBottom: "30px",
                backgroundColor: "transparent",
                mixBlendMode: "multiply",
                position: "absolute",
                top: "20mm",
                left: "20mm",
              }}
            />
          </div>
        </div>
      </div>

      {streams.map((stream) =>
        stream.learning_activities?.map((activity) =>
          activity.curriculums?.map((item, index) => {
            const {
              curriculum = {},
              runtime_competency_rate = 0,
              homework_rate = 0,
              parent_engagement_rate = 0,
              pending_homework = 0,
              submitted_homework = 0,
              verified_homework = 0,
              total_homework = 0,
              profile_risk = "",
              progress_status = "",
              status = "",
              overall_summary = {},
            } = item;


            return (
              <div
                key={item._id || index}
                className="pdf-page"
                style={{
                  width: "210mm",
                  minHeight: "297mm",
                  padding: "8mm",
                  margin: "0 auto 15px auto",
                  background: "#fff",
                  border: "1px solid #ccc",
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  pageBreakAfter: "always",
                  overflow: "hidden",
                }}
              >
                <div style={{
                  display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "10px",
                  padding: "8px",
                  background: "#f9f9f9",
                }}>
                  <Title level={3} style={{ color: "#50B6F2", margin: 0 }}>
                    {activity.name}
                  </Title>

                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "8px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      breakInside: "avoid",
                      pageBreakInside: "avoid",
                    }}
                  >
                    <Title level={4} style={{ color: "#50B6F2", margin: "0 0 6px 0" }}>
                      {curriculum?.name || "Curriculum"}{" "}
                      {curriculum?.nominal_year_level ? `(Level ${curriculum.nominal_year_level})` : ""}
                    </Title>

                    <div
                      style={{
                        background: "#f2f2f2",
                        padding: "10px",
                        fontSize: "12px",
                        breakInside: "avoid",
                        pageBreakInside: "avoid",
                      }}
                    >
                      <b style={{ color: "#50B6F2" }}>Subject Outline</b>
                      <p style={{ textAlign: "justify" }}>
                        In <b>{report_period}</b>, students improved various skills related to <b>{curriculum?.name}</b> through engaging lessons and assessments.
                      </p>
                    </div>


                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", breakInside: "avoid", pageBreakInside: "avoid" }}>
                      <div style={{ flex: 1 }}>
                        <h4 style={{ marginBottom: "2px", fontWeight: "bold" }}>Academic Performance</h4>
                        <table style={{ width: "100%", fontSize: "12px" }}>
                          <tbody>
                            <tr><td>1. Competency Rate</td><td>{runtime_competency_rate.toFixed(2)}%</td></tr>
                            <tr><td>2. Homework Rate</td><td>{homework_rate}%</td></tr>
                            <tr><td>3. Parent Engagement Rate</td><td>{parent_engagement_rate}%</td></tr>
                            <tr><td>4. Profile Risk</td><td style={{ color: profile_risk === "high" ? "#FF1A1A" : profile_risk === "medium" ? "#F3CC00" : "#00CE08", fontWeight: "bold" }}>{profile_risk && profile_risk.charAt(0).toUpperCase() + profile_risk.slice(1).toLowerCase()}</td></tr>
                            <tr><td>5. Progress Status</td><td>{progress_status}</td></tr>
                            <tr><td>6. Curriculum Status</td><td>{status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : "-"}</td></tr>
                          </tbody>
                        </table>
                      </div>

                      <div style={{ flex: 1 }}>
                        <h4 style={{ marginBottom: "2px", fontWeight: "bold" }}>Homework Progress</h4>
                        <table style={{ width: "100%", fontSize: "12px" }}>
                          <tbody>
                            <tr><td>1. Submitted Homework</td><td>{submitted_homework}</td></tr>
                            <tr><td>2. Verified Homework</td><td>{verified_homework}</td></tr>
                            <tr><td>3. Pending Homework</td><td>{pending_homework}</td></tr>
                            <tr><td>4. Total Homework</td><td>{total_homework}</td></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {overall_summary && Object.keys(overall_summary).length > 0 && (
                      <div style={{ marginTop: "10px", border: "1px solid #ddd", borderRadius: "8px", padding: "10px", background: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.05)", breakInside: "auto", pageBreakInside: "auto" }}>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <h4 style={{ marginBottom: "3px", color: "#50B6F2" }}>Observations:</h4>
                          <p style={{ marginBottom: "0" }}>We are showing only the mistakes that were marked</p>
                        </div>
                        {(() => {
                          const globalMax = Math.max(...Object.values(overall_summary).flatMap(subs => Object.values(subs)));
                          return Object.entries(overall_summary).map(([category, subs], idx) => (
                            <div key={idx} style={{ marginBottom: "4px", padding: "4px", border: "1px solid #eee", borderRadius: "6px", background: "#fafafa" }}>
                              <p style={{ fontWeight: "600", marginBottom: "3px", fontSize: "14px", color: "#333" }}>{category}</p>
                              {Object.entries(subs).map(([subName, count]) => {
                                const barWidth = globalMax ? (count / globalMax) * 100 : 0;
                                return (
                                  <div key={subName} style={{ display: "flex", alignItems: "center", fontSize: "12px", marginBottom: "3px" }}>
                                    <div style={{ width: "130px" }}>{subName}</div>
                                    <div style={{ width: "1px", background: "#ccc", height: "12px", margin: "0 6px" }} />
                                    <div style={{ flex: 1, height: "12px", position: "relative" }}>
                                      <div style={{ width: `${barWidth}%`, background: "#50B6F2", height: "100%", borderRadius: "2px" }} />
                                    </div>
                                    <div style={{ minWidth: "28px", textAlign: "right", fontWeight: "bold" }}>{count}</div>
                                  </div>
                                );
                              })}
                            </div>
                          ));
                        })()}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )
      )}
    </>
  );
};

export default TermReportTable;
